import React, { ReactNode } from "react";
import styled from "styled-components";
import { useSiweMutation } from "../../queries/authentication.query";
import Button from "./Buttons/Button";
import Typography from "./Typography/Typography";
import { getHorizontalGap } from "../styles";
import Icon from "./Icon/Icon";

const Root = styled.div`
  margin: 0 auto;
  padding: 0 20px;
`;

const Container = styled.div`
  padding: 100px 0 40px 0;
  margin: 0 auto;
  max-width: 640px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    padding-top: 40px;
  }
`;

const Title = styled(Typography)`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    font-size: ${({ theme }) => theme.heading.sm};
  }
`;

const Warning = styled.div`
  margin: 64px 0 16px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    margin-top: 32px;
  }
`;

const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  ${getHorizontalGap("12px")};
`;

const Divider = styled.div`
  margin: 56px 0;
  display: flex;
  align-items: center;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => theme.borderColor};
  }
`;

const DividerText = styled(Typography)`
  padding: 0 32px;
`;

interface IProps {
  title: string;
  actionText: string;
  dividerText: string;
  children: ReactNode;
}

const EthLogin = ({ children, title, actionText, dividerText }: IProps) => {
  const { mutate: ethLogin, isLoading } = useSiweMutation();

  return (
    <Root>
      <Container>
        <Title heading weight="500" size="lg" fontFamily="Poppins">
          {title}
        </Title>
        <Warning>
          <Typography secondary size="sm" id="login-duplication-warning" />
        </Warning>
        <Button
          fullWidth
          height="48px"
          label={
            <ButtonLabel>
              <Icon name="eth" size="16px" />
              <Typography weight="500">{actionText}</Typography>
            </ButtonLabel>
          }
          onClick={ethLogin}
          isLoading={isLoading}
        />
        <Divider>
          <DividerText secondary size="sm">
            {dividerText}
          </DividerText>
        </Divider>
        {children}
      </Container>
    </Root>
  );
};

export default EthLogin;
